<template>
  <b-nav-item-dropdown v-show="bForced == false" right no-caret class="d-md-down-none">
    <!--  style="min-width: 140px;" -->
    <template slot="button-content">
      <img
        class="flag"
        :src="'/static/img/flags/' + currentLanguage + '.png'"
        :alt="currentLanguage"
      />
      {{ uniTranslation(currentLanguage) }}
    </template>
    <b-dropdown-item v-for="lang in languages" :key="lang" @click="changeLanguage(lang)">
      <img class="flag" :src="'/static/img/flags/' + lang + '.png'" :alt="lang" />
      {{ uniTranslation(lang) }}</b-dropdown-item
    >
  </b-nav-item-dropdown>
</template>
<script>
// import { loadLanguageAsync } from "../../i18n/index";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "HeaderDropdown",
  data: () => {
    return {
      coloreTesto: ""
    };
  },
  computed: {
    ...mapGetters("_translationModule", ["currentLanguage", "languages","bForced"])
  },
  mounted() {
    var that = this;
    that.changeLanguageAction(that.currentLanguage);
  },
  methods: {
    ...mapActions("_translationModule", ["changeLanguageAction"]),
    changeLanguage: function(lang) {
      if (lang !== this.currentLanguage) {
        this.changeLanguageAction(lang);
      }
    }
  }
};
</script>
<style lang="scss">
.flag {
  width: 24px;
  position: relative;
  top: -2px;
  margin-right: 3px;
  border: 1px darkgrey solid;
}
</style>
